import { getProductPath } from './productTypes';
export var getProductQuestionsPath = function getProductQuestionsPath(product) {
  return "".concat(getProductPath(product), "/preguntas");
};